module.exports = __webpack_public_path__ + "img/poster-icon.acc70da3.svg";